import { Injectable } from '@angular/core';
import { RequestService } from './requestService';

import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { take } from 'rxjs/operators';

@Injectable()
export class FinnService {
  // URL to web api
  private _apiEndpoint = environment.apiUrl + 'finn/';

  public reqFieldMessage: string;

  // AS DEFINED at: https://www.finn.no/finn/referencevalue?adType=JOB&xmlCode=sector
  private sectors = {
    0: { value: 'PRIVATE', text: 'Privat' },
    1: { value: 'PUBLIC', text: 'Offentlig' },
    2: { value: 'ORGANISATIONS', text: 'Organisasjoner' },
    3: { value: 'COOPERATIVE', text: 'Samvirke' },
    4: {
      value: 'SELFEMPLOYED',
      text: 'Franchise/Selvstendig næringsdrivende',
    },
  };

  // AS DEFINED at: https://www.finn.no/finn/referencevalue?adType=JOB&xmlCode=durations
  private durations = {
    0: { value: 'PERMANENT', text: 'Fast' },
    1: { value: 'TEMPORARY', text: 'Vikariat' },
    2: { value: 'FIXEDCONTRACT', text: 'Engasjement' },
    3: { value: 'PROJECT', text: 'Prosjekt' },
    4: { value: 'TRAINEE', text: 'Trainee' },
    5: { value: 'SEASONAL', text: 'Sommer/Sesong' },
    6: { value: 'SELFEMPLOYED', text: 'Selvstendig næringsdrivende' },
    7: { value: 'APPRENTICE', text: 'Lærling' },
  };

  constructor(
    private http: HttpClient,
    private _translate: TranslateService,
    private _requestService: RequestService
  ) {
    this._translate
      .get([
        'finn_sector_private',
        'finn_sector_public',
        'finn_sector_organisations',
        'finn_sector_cooperative',
        'finn_sector_selfemployed',
      ])
      .pipe(take(1))
      .subscribe(sectorStrings => {
        this.sectors = {
          0: {
            value: 'PRIVATE',
            text: sectorStrings['finn_sector_private'],
          },
          1: {
            value: 'PUBLIC',
            text: sectorStrings['finn_sector_public'],
          },
          2: {
            value: 'ORGANISATIONS',
            text: sectorStrings['finn_sector_organisations'],
          },
          3: {
            value: 'COOPERATIVE',
            text: sectorStrings['finn_sector_cooperative'],
          },
          4: {
            value: 'SELFEMPLOYED',
            text: sectorStrings['finn_sector_selfemployed'],
          },
        };
      });

    this._translate
      .get([
        'finn_duration_permanent',
        'finn_duration_temporary',
        'finn_duration_fixedcontract',
        'finn_duration_project',
        'finn_duration_trainee',
        'finn_duration_seasonal',
        'finn_duration_selfemployed',
        'finn_duration_apprentice',
      ])
      .pipe(take(1))
      .subscribe(durationStrings => {
        this.durations = {
          0: {
            value: 'PERMANENT',
            text: durationStrings['finn_duration_permanent'],
          },
          1: {
            value: 'TEMPORARY',
            text: durationStrings['finn_duration_temporary'],
          },
          2: {
            value: 'FIXEDCONTRACT',
            text: durationStrings['finn_duration_fixedcontract'],
          },
          3: {
            value: 'PROJECT',
            text: durationStrings['finn_duration_project'],
          },
          4: {
            value: 'TRAINEE',
            text: durationStrings['finn_duration_trainee'],
          },
          5: {
            value: 'SEASONAL',
            text: durationStrings['finn_duration_seasonal'],
          },
          6: {
            value: 'SELFEMPLOYED',
            text: durationStrings['finn_duration_selfemployed'],
          },
          7: {
            value: 'APPRENTICE',
            text: durationStrings['finn_duration_apprentice'],
          },
        };
      });

    this._translate
      .get('unit_description_fill_description')
      .pipe(take(1))
      .subscribe(message => {
        this.reqFieldMessage = message;
      });
  }

  public getSectors() {
    const sectors: {} = {};

    for (const i in this.sectors) {
      if (this.sectors[i]) {
        sectors[i] = this.sectors[i];
      }
    }
    return sectors;
  }

  public getDurations() {
    const durations: {} = {};

    for (const i in this.durations) {
      if (this.durations[i]) {
        durations[i] = this.durations[i];
      }
    }
    return durations;
  }

  public getFinnAdvertisementFormValues() {
    // Retrieves valid form value inputs from Finn.no, as they might change at any given time.
    return this._requestService.request('GET', this._apiEndpoint + 'values/');
  }

  private _validate_url(value) {
    const regex = new RegExp(
      [
        '^(?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)',
        '(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]',
        '\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5]))',
        '{2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\\.(?:[a-z\u00a1-\uffff0-9]-*)',
        '*[a-z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-z\u00a1-\uffff]{2,})))(?::\\d{2,5})?(?:[/?#]\\S*)?$',
      ].join('')
    );

    return regex.test(value);
  }
}
